import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({ standalone: false, selector: '[autostick]' })
export class AutoStick {
	@Input() dontCheckFixedTarget: boolean = false;
	@Input() addClassOnStick: string = '';
	@Input('autostick') stickToId: string;
	@Input() bottomstick: string;

	stickToObj: HTMLElement = null;
	bottomStickToObj: HTMLElement = null;

	isSticked: boolean = false;
	isStickedBottom: boolean = false;
	oPosition: string;
	oMarginLeft: string;
	oTop: string;
	bottomOTop: string;
	oLeft: string;
	oWidth: string;
	oClassName: string;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	replacementElement: any;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	parrentElement: any;
	beforeStickOffsetTop: number = 0;
	beforeBottomStickOffsetTop: number = 0;

	static autoSticks: Array<AutoStick>;
	static afterCheck() {
		for (let i in AutoStick.autoSticks) {
			AutoStick.autoSticks[i].doStickCheck();
			AutoStick.autoSticks[i].doBottomStickCheck();
		}
	}

	constructor(private el: ElementRef) {
		if (AutoStick.autoSticks === null || AutoStick.autoSticks === undefined) {
			AutoStick.autoSticks = [] as AutoStick[];
		}
		AutoStick.autoSticks.push(this);
	}
	ngOnDestroy() {
		this.isStickedBottom = false;
		this.unStick();
		let index = AutoStick.autoSticks.indexOf(this);
		if (index > -1) {
			AutoStick.autoSticks.splice(index, 1);
		}
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	ngOnChanges(changes: any) {
		this.stickToObj = document.getElementById(changes.stickToId.currentValue);
		window.setTimeout(() => {
			this.isStickedBottom = false;
			this.unStick();
			this.doStickCheck();
			this.doBottomStickCheck();
			AutoStick.afterCheck();
		}, 0);
	}

	ngAfterViewChecked() {
		if (this.isSticked) {
			let newLeft = this.getOffsetLeft(this.replacementElement);
			let newWidth = this.replacementElement.clientWidth;

			this.el.nativeElement.style.left = newLeft.toString() + 'px';
			this.el.nativeElement.style.width = newWidth.toString() + 'px';
		}
		this.doStickCheck();
		this.doBottomStickCheck();
	}

	@HostListener('window:scroll', ['$event.target'])
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	onWindowScroll(event: any) {
		/* empty function needed to trigger ngAfterViewChecked*/
	}

	@HostListener('window:resize', ['$event.target'])
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	onWindowResize(event: any) {
		/* empty function needed to trigger ngAfterViewChecked*/
	}

	doBottomStickCheck() {
		if (this.bottomstick === null) {
			return;
		}
		if (this.bottomStickToObj === null) {
			this.bottomStickToObj = document.getElementById(this.bottomstick);
			if (this.bottomStickToObj === null) {
				return;
			}
		}

		if (this.isSticked) {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			let boFromTopDist = this.getOffsetTop(this.bottomStickToObj) - scrollTop;
			let myBotPosFromTopDist = this.getOffsetTop(this.el.nativeElement);

			if (this.isStickedBottom) {
				myBotPosFromTopDist = this.beforeBottomStickOffsetTop;
			} else {
				this.beforeBottomStickOffsetTop = myBotPosFromTopDist;
			}
			myBotPosFromTopDist += this.el.nativeElement.clientHeight;

			if (boFromTopDist <= myBotPosFromTopDist) {
				if (this.isStickedBottom === false) {
					this.isStickedBottom = true;
					this.bottomOTop = this.el.nativeElement.style.top;
					AutoStick.afterCheck();
				}
				this.el.nativeElement.style.top = (boFromTopDist - this.el.nativeElement.clientHeight).toString() + 'px';
			} else {
				if (this.isStickedBottom === true) {
					this.isStickedBottom = false;
					this.el.nativeElement.style.top = this.bottomOTop;
					AutoStick.afterCheck();
				}
			}
		}
	}
	doStickCheck() {
		if (this.stickToObj === null) {
			this.stickToObj = document.getElementById(this.stickToId);
			if (this.stickToObj === null) {
				return;
			}
		}
		if (!this.isSticked) {
			this.beforeStickOffsetTop = this.getOffsetTop(this.el.nativeElement);
		} else {
			this.beforeStickOffsetTop = this.getOffsetTop(this.replacementElement);
		}
		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let thisPosInWin = this.beforeStickOffsetTop - scrollTop;
		let stickObjPos;

		if (
			this.stickToObj.style.position === 'fixed' ||
			this.dontCheckFixedTarget === true ||
			// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
			(this.dontCheckFixedTarget as any) === 'true'
		) {
			stickObjPos = this.getOffsetTop(this.stickToObj) + this.stickToObj.clientHeight;
		} else {
			stickObjPos = this.getOffsetTop(this.stickToObj) + this.stickToObj.clientHeight - scrollTop;
		}

		if (thisPosInWin < stickObjPos) {
			this.stick(stickObjPos);
		} else {
			this.unStick();
		}
	}
	stick(stickPos: number) {
		if (!this.isSticked) {
			this.replacementElement = document.createElement('div');
			this.replacementElement.className = this.el.nativeElement.className;
			this.replacementElement.style = this.el.nativeElement.style;
			this.replacementElement.style.height = this.el.nativeElement.clientHeight + 'px';
			this.replacementElement.style.opacity = '0';

			let newLeft = this.getOffsetLeft(this.el.nativeElement);
			let newWidth = this.el.nativeElement.clientWidth;
			//sav values
			this.oPosition = this.el.nativeElement.style.position;
			this.oMarginLeft = this.el.nativeElement.style.marginLeft;
			this.oTop = this.el.nativeElement.style.top;
			this.oLeft = this.el.nativeElement.style.left;
			this.oWidth = this.el.nativeElement.style.width;
			this.oClassName = this.el.nativeElement.className;
			//set new values
			this.el.nativeElement.style.position = 'fixed';
			this.el.nativeElement.style.marginLeft = '0px';
			this.el.nativeElement.style.top = stickPos.toString() + 'px';
			this.el.nativeElement.style.left = newLeft.toString() + 'px';
			this.el.nativeElement.style.width = newWidth.toString() + 'px';

			this.parrentElement = this.el.nativeElement.parentElement;
			this.parrentElement.insertBefore(this.replacementElement, this.el.nativeElement);

			//on stick class add
			if (this.addClassOnStick !== null && this.addClassOnStick !== '') {
				this.el.nativeElement.className += ' ' + this.addClassOnStick;
			}

			this.isSticked = true;
		}
	}
	unStick() {
		if (this.isSticked) {
			this.el.nativeElement.style.position = this.oPosition;
			this.el.nativeElement.style.marginLeft = this.oMarginLeft;
			this.el.nativeElement.style.top = this.oTop;
			this.el.nativeElement.style.left = this.oLeft;
			this.el.nativeElement.style.width = this.oWidth;
			this.el.nativeElement.className = this.oClassName;

			this.parrentElement.removeChild(this.replacementElement);

			this.isSticked = false;
		}
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	getOffsetTop(element: any): number {
		if (element.offsetParent !== null) {
			return element.offsetTop + this.getOffsetTop(element.offsetParent);
		} else {
			return element.offsetTop;
		}
	}
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	getOffsetLeft(element: any): number {
		if (element.offsetParent !== null) {
			return element.offsetLeft + this.getOffsetLeft(element.offsetParent);
		} else {
			return element.offsetLeft;
		}
	}
}
